(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name TransporteController
* @description
* This is main controller
**/ 

    angular
    .module('appback')
    .controller('TransporteController', TransporteController);

    TransporteController.$inject = ["TransportesService","$timeout","$location",'$anchorScroll','$window'];

    function TransporteController(TransportesService,$timeout,$location,$anchorScroll,$window)
    {
    	//console.log("TransporteController Enabled");
    	var vm = this;
    	vm.zonas = [];
    	vm.transportes = [];
    	vm.loading = false;
    	vm.init = function(){
    		TransportesService.getTransportes(function(data){
               vm.zonas = data.zonas;
               vm.transportes = data.transportes;
            });
    	}

    	vm.guardar = function(){
    		vm.loading = true;
    		TransportesService.guardar(vm,function(data){
               vm.transportes = data.transportes;
    			vm.loading = false;
            });
    	}

    	vm.eliminar = function(transporte){
    		for(var cont=0;cont<vm.transportes.length;cont++){
    			if(vm.transportes[cont].grupo==transporte.grupo){
    				vm.transportes[cont].active=0;
    			}
    		}
    	}

    	vm.nuevo = function(){
    		var grupo = vm.transportes.length * -1;
    		for(var cont=0;cont<vm.zonas.length;cont++){
    			vm.transportes.push({
    				grupo: grupo,
    				rango_desde:'',
    				rango_hasta:'',
    				zona_id:vm.zonas[cont].id,
    				precio:'',
    				active:1
    			});
    		}
    	}
    	vm.init();
        
    }
})();